/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'folder': {
    width: 16,
    height: 16,
    viewBox: '0 0 60 60',
    data: '<path pid="0" _fill="#7d7d7d" d="M12.4 21.2h35.3v3.5H12.4z"/><path pid="1" d="M51.9 56.5H8.1L0 48.4V3.5h27.6l3.5 7.1H60v37.8l-8.1 8.1zM9.6 52.9h40.9l6-6V14.1H28.9L25.4 7H3.5v39.9l6.1 6z" _fill="#7d7d7d"/>'
  }
})
